import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const smsSend = async (param) => {
  const { data } = await axios.post(`${baseUrl}/sms/send`, param);
  return data;
};

const kakaoForInquiryMember = async (param) => {
  const { data } = await axios.post(`${baseUrl}/kakao/inquiry/member`, param);
  return data;
};

const kakaoForInquiryNonMember = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/kakao/inquiry/nonMember`,
    param,
  );
  return data;
};

const kakaoForDelivery = async (param) => {
  const { data } = await axios.post(`${baseUrl}/kakao/delivery`, param);
  return data;
};

const kakaoForDepositCancel = async (param) => {
  const { data } = await axios.post(`${baseUrl}/kakao/deposit/cancel`, param);
  return data;
};

const kakaoForCancelRequestRefusal = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/kakao/friend/cancelRequestRefusal`,
    param,
  );
  return data;
};

const kakaoForFriend = async (param) => {
  const { data } = await axios.post(`${baseUrl}/kakao/friend/etc`, param);
  return data;
};

const pushApi = {
  smsSend,
  kakaoForInquiryMember,
  kakaoForInquiryNonMember,
  kakaoForDelivery,
  kakaoForDepositCancel,
  kakaoForCancelRequestRefusal,
  kakaoForFriend,
};

export default pushApi;
